import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'g10-organization-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {
  // user data
/*   public notificationObj={
    "alertConfiguration":{
      "sms": true,
      "call": false,
      "email": false,
      "app": false,
    },
    "reportConfiguration":{
      "overspeed": true,
      "geofence": true,
      "sos": false,
    },
    "orgID": "60866279d774d4408635033b"
  }; */
  public tabs = {
    isViewNotification:true,
    isAlertNotification:false,
    isMobileConfig:false,
    isEmailConfig:false,
    isManageGroup:false,
  };
  
  constructor() { 
    }

  ngOnInit(): void {
  }

  reloadTab(tab){

    for(let key in this.tabs){
      if(key==tab) this.tabs[key]=true;
      else this.tabs[key]=false;
    }
    
  }

}
